<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import { orderOriginMethods, orderOriginComputed } from "@/state/helpers";
import Swal from "sweetalert2";

export default {
  components: { Layout, PageHeader },
  data() {
    return {
      form: {
        id: "",
        name: "",
        image: null,
      },
      title: "All Order Origins",
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      selectedOriginImage: require("@/assets/images/placeholder.webp"),
    };
  },
  computed: {
    ...orderOriginComputed,
  },
  methods: {
    ...orderOriginMethods,
    createNewOrderOrigin(event) {
      event.preventDefault();

      this.addOrderOrigin({
        name: this.form.name,
        image: this.form.image,
      })
        .then(function () {
          Swal.fire("Item Created!", "", "success");
        })
        .catch((error) => {
          Swal.fire({
            icon: "error",
            title: "An error occured",
            text: JSON.stringify(error),
          });
        });

      this.form.name = "";
      this.form.image = null;
      this.$bvModal.hide("create-new-item");
    },
    editOrderOrigin(orderOrigin) {
      this.form.id = orderOrigin.id;
      this.form.name = orderOrigin.name;
      this.form.image = orderOrigin.image;
      this.$bvModal.show("edit-item");
    },
    updateOrderOrigin(event) {
      event.preventDefault();

      this.updatedOrderOrigin({
        id: this.form.id,
        name: this.form.name,
        image: this.form.image,
      })
        .then(function () {
          Swal.fire("Item updated!", "", "success");
        })
        .catch((error) => {
          Swal.fire({
            icon: "error",
            title: "An error occured",
            text: JSON.stringify(error),
          });
        });

      this.form.id = "";
      this.form.name = "";
      this.form.image = null;
      this.$bvModal.hide("edit-item");
    },
    deleteOrderOrigin(orderOriginID) {
      Swal.fire({
        title: "Do you want to delete this item",
        showDenyButton: true,
        showCancelButton: false,
        confirmButtonText: "Yes",
        denyButtonText: `No`,
      }).then((result) => {
        /* Read more about isConfirmed, isDenied below */
        if (result.isConfirmed) {
          this.removeOrderOrigin(orderOriginID)
            .then(function () {
              Swal.fire("Item Deleted!", "", "success");
            })
            .catch((error) => {
              Swal.fire({
                icon: "error",
                title: "An error occured",
                text: JSON.stringify(error),
              });
            });
        }
      });
    },
    hideCreateNewModal(modelID) {
      this.form.name = "";
      this.$bvModal.hide(modelID);
    },
    getOrderOrigins(page) {
      let thisInstance = this;
      if (isNaN(page)) {
        page = 1;
      }
      thisInstance.currentPage = page;
      thisInstance
        .loadOrderOrigins({
          page: thisInstance.currentPage,
          perPage: thisInstance.perPage,
        })
        .then(
          function (orderOrigins) {
            thisInstance.totalRows = orderOrigins.total;
          },
          function (error) {
            Swal.fire({
              icon: "error",
              title: "An error occured",
              text: JSON.stringify(error),
            });
          }
        );
    },
    onPageSizeChange() {
      this.getOrderOrigins();
    },
    setSelectedOriginImage(event) {
      let tgt = event.target || window.event.srcElement;
      let files = tgt.files;
      const reader = new FileReader();
      reader.onload = () => {
        this.selectedOriginImage = reader.result;
      };
      reader.readAsDataURL(files[0]);
      this.form.image = files[0];
    },
    getImagePath(file) {
      if (!file) {
        return false;
      }
      if (file.constructor.name === "File") {
        return URL.createObjectURL(file);
      }
      return this.resolveImagePath(file);
    },
  },
  mounted() {
    this.getOrderOrigins();
  },
  created() {
    this.$root.$on("bv::modal::hidden", () => {
      this.form.id = "";
      this.form.name = "";
      this.form.image = null;
    });
  },
};
</script>
      
<template>
  <Layout>
    <PageHeader :title="title" />

    <!-- create new item modal -->
    <b-modal id="create-new-item" title="Create new" :hide-footer="true">
      <b-form @submit="createNewOrderOrigin">
        <div class="card">
          <div class="card-body">
            <div class="row mb-2">
              <div class="col-12">

                <label for="origin-image">
                  <span class="d-inline-block mb-1">Origin Image</span>
                  <b-img
                  class="d-block w-25"
                    thumbnail
                    fluid
                    :src="getImagePath(form.image) || selectedOriginImage"
                  ></b-img>
                  <input
                    class="d-none"
                    type="file"
                    id="origin-image"
                    accept="image/png, image/jpeg"
                    name="origin-image"
                    @change="setSelectedOriginImage"
                  />
                </label>

                <b-form-group
                  id="origin-name-group"
                  label="Origin title:"
                  label-for="origin-name"
                  class="mb-3"
                >
                  <b-form-input
                    id="origin-name"
                    type="text"
                    v-model="form.name"
                    required
                  ></b-form-input>
                </b-form-group>

              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <b-button class="me-2" type="submit">
                  <span>Submit</span>
                </b-button>

                <b-button @click="hideCreateNewModal('create-new-item')">
                  <span>Cancel</span>
                </b-button>
              </div>
            </div>
          </div>
        </div>
      </b-form>
    </b-modal>
    <!-- create new item modal -->

    <!-- edit item modal -->
    <b-modal id="edit-item" title="Edit" :hide-footer="true">
      <b-form @submit="updateOrderOrigin">
        <div class="card">
          <div class="card-body">
            <div class="row mb-2">
              <div class="col-12">

                <label for="origin-image">
                  <span class="d-inline-block mb-1">Origin Image</span>
                  <b-img
                  class="d-block w-25"
                    thumbnail
                    fluid
                    :src="getImagePath(form.image) || selectedOriginImage"
                  ></b-img>
                  <input
                    class="d-none"
                    type="file"
                    id="origin-image"
                    accept="image/png, image/jpeg"
                    name="origin-image"
                    @change="setSelectedOriginImage"
                  />
                </label>

                <b-form-group
                  id="origin-name-group"
                  label="Origin title:"
                  label-for="origin-name"
                >
                  <b-form-input
                    id="origin-name"
                    type="text"
                    v-model="form.name"
                    required
                  ></b-form-input>
                </b-form-group>
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <b-button class="me-2" type="submit">
                  <span>Submit</span>
                </b-button>

                <b-button @click="hideCreateNewModal('edit-item')">
                  <span>Cancel</span>
                </b-button>
              </div>
            </div>
          </div>
        </div>
      </b-form>
    </b-modal>
    <!-- edit item modal -->

    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <b-button v-b-modal.create-new-item>
              <span>Create Order Origin</span>
            </b-button>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <!-- Table -->
            <div class="table-responsive mb-0">
              <table class="table table-bordered">
                <thead>
                  <tr>
                    <th scope="col">ID</th>
                    <th scope="col">Image</th>
                    <th scope="col">Name</th>
                    <th scope="col">Creation Date</th>
                    <th scope="col">Actions</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="orderOrigin in orderOrigins" :key="orderOrigin.id">
                    <td>{{ orderOrigin.id }}</td>
                    <td>
                      <b-img
                        class="d-block"
                        style="width: 30px"
                        :src="getImagePath(orderOrigin.image) || selectedOriginImage"
                      >
                      </b-img>
                    </td>
                    <td>{{ orderOrigin.name }}</td>
                    <td>
                      {{ moment(orderOrigin.created_at).format("YYYY-MM-DD") }}
                    </td>
                    <td>
                      <div class="d-flex" v-if="!orderOrigin.system_generated">
                        <b-button
                          class="m-1"
                          @click="
                            editOrderOrigin(orderOrigin)
                            "
                          size="sm"
                          >Edit</b-button
                        >
                        <b-button
                          class="m-1"
                          @click="deleteOrderOrigin(orderOrigin.id)"
                          size="sm"
                          >Delete</b-button
                        >
                      </div>
                      <div v-else>
                        <span class="d-inline border rounded p-2 m-1 py-1">
                          System generated
                        </span>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="row">
              <div class="col">
                <label class="d-inline-flex align-items-center">
                  <span class="p-2">Show</span>
                  <b-form-select
                    class="form-select form-select-sm"
                    v-model="perPage"
                    size="sm"
                    :options="pageOptions"
                    @change="onPageSizeChange"
                  ></b-form-select>
                  <span class="p-2">entries</span>
                </label>
              </div>
              <div class="col">
                <div
                  class="dataTables_paginate paging_simple_numbers float-end"
                >
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                      v-model="currentPage"
                      :total-rows="totalRows"
                      :per-page="perPage"
                      @change="getOrderOrigins"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>